import FixedNavBar from "@/components/fixedNavBar";
import useCustomTranslation from "@/hooks/useTranslation";
import { pxToRem } from "@/util/common";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import CalendarTime from "@/components/calendarTime";
import DropTime from "@/components/dropTime";
import RecommendList from "@/components/recommendList";
import { showGlobalLoading } from "@/components/globalLoading";
import API from "@/api";
import { RecommendItem } from "@/api/type";

const CalendarTimeChildComponent = forwardRef(CalendarTime);
const RecommendRecords: React.FC = () => {
	const { t } = useCustomTranslation();
	const { showLoading, hideLoading } = showGlobalLoading();
	const childRef = useRef<any>(null);

	const [data, setData] = useState<RecommendItem[]>([]);
	const [hasMore, setHasMore] = useState(true);
	const [page, setPage] = useState(0);
	const pageSize = 20;

	const postFinanceOrderWaterListHandle = async (isRefresh = false) => {
		try {
			let pageNum = isRefresh ? 0 : page;
			const params: any = {
				page: pageNum,
				pageSize: pageSize,
			};
			if (childRef.current) {
				params["startTime"] = childRef.current.startTime;
				params["endTime"] = childRef.current.endTime;
			}
			showLoading();
			const result: any = await API.finances.apiFinanceOrderWaterList(
				params
			);
			if (result?.code === 0) {
				const contentData = result.content.data;
				const haveMore = result.content.haveMore;

				setHasMore(haveMore);
				if (haveMore) {
					if (isRefresh) {
						setPage(1);
					} else {
						setPage((prevPage) => prevPage + 1);
					}
				}
				if (pageNum === 0) {
					setData(contentData);
				} else {
					setData((prevData) => [...prevData, ...contentData]);
				}
			}
		} catch (error) {
			console.log("---apiFinanceOrderWaterList--:", error);
		} finally {
			hideLoading();
		}
	};
	const handleRefresh = async () => {
		// 模拟刷新数据
		await postFinanceOrderWaterListHandle(true);
	};

	const handleFetchMore = async () => {
		// 模拟加载更多数据
		await postFinanceOrderWaterListHandle();
	};

	useEffect(() => {
		postFinanceOrderWaterListHandle();
	}, []);

	const daysToSubtract = useRef<number>(30);
	const handleOptionClick = (newIndex: number) => {
		daysToSubtract.current = newIndex;
		postFinanceOrderWaterListHandle();
	};

	return (
		<div className="router-main">
			<FixedNavBar
				title={`${t("MyRecommend")}`}
				rightContent={[
					<DropTime
						key="dropTime"
						index={daysToSubtract.current}
						handleOptionClick={handleOptionClick}
					/>,
				]}
			/>
			<div
				style={{ paddingLeft: pxToRem(20), paddingRight: pxToRem(20) }}
			>
				<CalendarTimeChildComponent
					ref={childRef}
					onSubmit={handleRefresh}
					daysToSubtract={daysToSubtract.current}
				/>
			</div>

			<div className="router-view">
				<RecommendList
					data={data}
					hasMore={hasMore}
					onRefresh={handleRefresh}
					onLoadMore={handleFetchMore}
					isPullToRefresh={true}
					isInside={true}
				/>
			</div>
		</div>
	);
};

export default RecommendRecords;
